$(document).ready(function () {
  console.log("activity_sale_tablsit ready")

  function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) >= 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  if ($(".tab_collection_item_box").length > 0) {
    // $($(".tab_collection_item_box")[0]).addClass("is-active")
    $(".animation_activity_tablist .mandishaire_tab_bar.in_box").on("click", ".mandishaire_tab_bar_item", function () {
      // console.log("点击")
      let data_ids = $(this).attr("data-idx")
      // console.log("点击s1:", data_ids)
      $(this).addClass("is-active")
      $(this).siblings(".is-active").removeClass("is-active")

      $($(".animation_activity_tablist .mandishaire_tab_bar.heade_top .mandishaire_tab_bar_item")[data_ids - 1]).addClass("is-active")
      $($(".animation_activity_tablist .mandishaire_tab_bar.heade_top .mandishaire_tab_bar_item")[data_ids - 1]).siblings(".is-active").removeClass("is-active")
      //
      let timer = setTimeout(() => {
        // clearTimeout(timer);
        // $
        let new_scroll_top = $(".animation_activity_tablist .tab_collection_item_list" + " .tab_collection_item_box")[data_ids - 1].offsetTop - 160
        document.documentElement.scrollTop = new_scroll_top
        // document.documentElement.scrollTop
      }, 100)
      // $($(".tab_collection_item_box")[data_ids - 1]).addClass("is-active")
      // $($(".tab_collection_item_box")[data_ids - 1]).siblings(".is-active").removeClass("is-active")
    })
    $(".animation_activity_tablist .mandishaire_tab_bar.heade_top").on("click", ".mandishaire_tab_bar_item", function () {
      let data_ids = $(this).attr("data-idx")
      // console.log("点击s1:", data_ids)
      $(this).addClass("is-active")
      $(this).siblings(".is-active").removeClass("is-active")
      $($(".animation_activity_tablist .mandishaire_tab_bar.in_box .mandishaire_tab_bar_item")[data_ids - 1]).addClass("is-active")
      $($(".animation_activity_tablist .mandishaire_tab_bar.in_box .mandishaire_tab_bar_item")[data_ids - 1]).siblings(".is-active").removeClass("is-active")
      //
      let timer = setTimeout(() => {
        // clearTimeout(timer);
        // $
        let new_scroll_top = $(".animation_activity_tablist .tab_collection_item_list" + " .tab_collection_item_box")[data_ids - 1].offsetTop - 160
        document.documentElement.scrollTop = new_scroll_top
        // document.documentElement.scrollTop
      }, 100)
    })

  }
  $(document).on("scroll", function () {
    // console.log("scroll:", document.documentElement.scrollTop, $(".mandishaire_tab_bar.in_box")[0].scrollTop)
    let timer = setTimeout(() => {
      let collection_item_box = $(".tab_collection_item_box")
      // console.log("collection_item_box", collection_item_box)
      let idx = 0
      for (let i = 0; i < collection_item_box.length; i++) {
        if (Number(collection_item_box[i].offsetTop - Number($(document.documentElement)[0].clientHeight)) < document.documentElement.scrollTop) {
          idx = i + 1
        }
      }
      if (idx > 0) {
        // console.log("初始化", idx - 1, $(".mandishaire_tab_bar.in_box .mandishaire_tab_bar_item")[idx - 1])
        $($(".mandishaire_tab_bar.in_box .mandishaire_tab_bar_item")[idx - 1]).addClass("is-active")
        $($(".mandishaire_tab_bar.in_box .mandishaire_tab_bar_item")[idx - 1]).siblings(".is-active").removeClass("is-active")
        $($(".mandishaire_tab_bar.heade_top .mandishaire_tab_bar_item")[idx - 1]).addClass("is-active")
        $($(".mandishaire_tab_bar.heade_top .mandishaire_tab_bar_item")[idx - 1]).siblings(".is-active").removeClass("is-active")
      } else {
        $(".mandishaire_tab_bar.in_box .mandishaire_tab_bar_item").removeClass("is-active")
        $(".mandishaire_tab_bar.heade_top .mandishaire_tab_bar_item").removeClass("is-active")
      }
    }, 500)
    // mandishaire_tab_bar heade_top
    // console.log("scroll", document.documentElement.scrollTop, $(".mandishaire_tab_bar.in_box")[0].offsetTop)

    // mandishaire_tab_bar in_box
    setTimeout(() => {
      if ($(".mandishaire_tab_bar.in_box")[0].offsetTop - 110 <= document.documentElement.scrollTop) {
        // console.log("显示")
        if (!IsPC()) {
          $(".mandishaire_tab_bar.heade_top").addClass("active")
        }
        $(".mandishaire_tab_bar.in_box").addClass("unactive")
      } else {
        // console.log("waht")
        $(".mandishaire_tab_bar.in_box").removeClass("unactive")
        if (!IsPC()) {
          $(".mandishaire_tab_bar.heade_top").removeClass("active")
        }
      }
    }, 500)
  })
  $(".proList-item_img--quick").on("click", function (e) {
    e.stopPropagation()
    e.preventDefault()
    // console.log("点击", $(this).siblings(".drawer--quick-buy"))
    let product_url = $(this).attr("data-url") || ""
    window.location.href = product_url
  })
  // $("#main")[0].addEventListener("scroll", function (res) {
  //   console.log("滚动")
  // })
  // $("html").on("scroll", function () {
  //   console.log("scroll")
  // })
  // $("html body")[0].addEventListener("scroll", function (res) {
  //   console.log("res:", res)
  // })
  $(".tab_collection_item_list .to_view_more").on("click", function () {
    console.log("url", $(this).attr("data-collect_url"))
    let collect_url = $(this).attr("data-collect_url")
    location.href = collect_url
  })

  // $("#main").on("scroll", function (e) {
  //   console.log("e", e)
  // })

})
